import React from 'react';

const StudioTopBar = ({
  children,
  title = 'Studio',
  showTitle = true,
}) => (
  <div className="studio-topbar">
    {showTitle && <div className="studio-topbar-title">{title}</div>}
    <div className="studio-topbar-actions">
      {children || <span className="studio-topbar-placeholder">Top Bar</span>}
    </div>
  </div>
);

export default StudioTopBar;
